export default "__VITE_ASSET__Cbdfzm2w__"